import { FileDashed } from '@phosphor-icons/react';

export default FileDashed;
